import React from 'react';
import BuilderActions from '../../builder/action/builderActions';
import PanelActions from '../../panel/action/panelActions';
import { findIndex } from 'underscore';
import clone from 'clone';
import classNames from 'classnames';
const $ = jQuery;


class SearchBlock extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isEditable: API.isEditable ? true : false,
      };
    }
    componentWillMount() {
      this.setState({ isEditable: this.props.isEditable });
    }

    componentDidMount() {
      if (this.state.isEditable) {
        $('.sortable').sortable({
          handle: '.block-shortable',
          stop: this.handleSort.bind(this),
        });
        $('.sortable').disableSelection();
      }
    }

    componentWillReceiveProps(nextProps) {
      this.allLayout = clone(nextProps.allLayout);
      this.setState({ isEditable: nextProps.isEditable });
    }
    handleSort(event) {
      const sortedsearchAttr = [];
      $(event.target).children().each((index, item) => {
        const childUid = String($(item).data('uid'));
        if (childUid !== 'undefined') {
          const filteredAttr = _.where(this.props.searchAttr, { uid: childUid });
          if (filteredAttr.length) {
            sortedsearchAttr.push(filteredAttr[0]);
          }
        }
      });
      const targetLayout = findIndex(this.allLayout, { uid: this.props.uid });
      if (targetLayout !== -1) {
        this.allLayout[targetLayout].searchAttr = sortedsearchAttr;
      }
      const pushLayout = {
        'allLayout': this.allLayout,
        'shortcodeKey': this.props.shortcodeKey,
        'return': 'dont',
      };
      BuilderActions.saveAllBlocks(pushLayout);
    }
    deleteSearch(uid, e) {
      e.preventDefault();
      const find = findIndex(this.allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchAttr = findIndex(this.allLayout[find].searchAttr, { uid });
        if (findSearchAttr !== -1) {
          this.allLayout[find].searchAttr.splice(findSearchAttr, 1);
        }
      }
      const pushLayout = {
        'allLayout': this.allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuilderActions.saveAllBlocks(pushLayout);
    }
    editSearch(search, e) {
      e.preventDefault();
      PanelActions.togglePanel('search-' + search.viewType, this.props.shortcodeKey, this.props.uid, search.uid);
    }
    capitalize(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    render() {
      const { previewData, settingsData } = this.props;
      this.allLayout = clone(this.props.allLayout);
      const indexOfPresentSearchBlock = findIndex(this.allLayout, { uid: this.props.uid });
      const templateType = this.allLayout[indexOfPresentSearchBlock].styleTemplate === undefined ? 'default' : this.allLayout[indexOfPresentSearchBlock].styleTemplate;
      let template = null;
      const customCssClass = this.allLayout[indexOfPresentSearchBlock].customCssClass;
      switch (templateType) {
        case 'dropdown':
          template = 'dropdown';
          break;
        default:
          template = 'default';
          break;
      }
      const showSearchAttr = (search, index) => {
        if (this.props.isToggle === false || this.props.isToggle === 'false')
          return;
        const self = this;
        let showSearchComponent;
        const presentSearchBlockTemplates = window.ReactiveTheme[settingsData.theme].search[template];
        const indexOfsearchItem = findIndex(presentSearchBlockTemplates, { type: search.viewType });
        if (indexOfsearchItem !== -1) {
          const searchItem = presentSearchBlockTemplates[indexOfsearchItem];
          showSearchComponent = <searchItem.component previewData={previewData} block={search} dropdonwtoggle={this.props.dropdonwtoggle} {...this.props} urlData={this.props.urlData}/>;
        }
        const customClassName = this.allLayout[indexOfPresentSearchBlock].styleType;
        return (<div className= {customClassName === 'horizontal' ? 'horizontal-elements' : null } key={'showSearchElement-' + index} data-uid={search.uid} data-type={search.viewType} data-parent={this.props.uid}>
        { this.state.isEditable ? <div className="child-block-handle">
          <a href="#" className="block-shortable">
            <i className="fa fa-ellipsis-h"></i>
          </a>
          <label style={ { marginLeft: '30px' } }>{this.capitalize(search.viewType)}</label>
          <div className="block-edit-button">
            <a className="edit-button" href="#" onClick={self.editSearch.bind(self, search)} >
              <i className="fa fa-pencil"></i>
            </a>
            <div className="hidden-button-block">
              <div>
                <a href="#" onClick={self.deleteSearch.bind(self, search.uid)} >
                  <i className="fa fa-times"></i>
                </a>
              </div>
            </div>
          </div>
          </div> : null}
          <div className="search-field-content">
            { this.props.urlData ? showSearchComponent : null}
          </div>
        </div>);
      };
      const parentClass = classNames({
        'sortable': true,
        'horizontal-parent': this.allLayout[indexOfPresentSearchBlock].styleType === 'horizontal',
        'horizontal-parent-dropdown': this.allLayout[indexOfPresentSearchBlock].styleTemplate === 'dropdown'
      });
      const ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-reactive-search-container' : '';
      return (<div className={ ifOpen + ' ' + parentClass + ' ' }>
        { this.props.searchAttr.map(showSearchAttr) }
      </div>);
    }
}

SearchBlock.propTypes = {
  'previewData': React.PropTypes.object,
  'settingsData': React.PropTypes.object,
  'searchAttr': React.PropTypes.array,
  'allLayout': React.PropTypes.array,
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'urlData': React.PropTypes.object,
  'isToggle': React.PropTypes.bool,
};

export default SearchBlock;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/searchBlock.js